<template>
  <div class="overlay no-close">
    <div class="contact-popup no-close">
      <img class="contact-popup__close-button no-close" :src="$image('menu_close.svg')" @click="$emit('close')" alt="" />
      <div class="contact-popup__body no-close">
        <div class="contact-popup__body__title no-close">九九～フリーモード～</div>
        <div class="contact-popup__body__heading no-close">お問い合わせ</div>
        <div class="contact-popup__body__mail no-close">
          <a :href="`mailto:kumon_ictmonitor@kumon.co.jp?${mail}`" target="_blank">
            kumon_ictmonitor@kumon.co.jp
          </a>
        </div>
        <div class="contact-popup__body__description no-close">
          お問い合わせ内容と合わせて、教室名、生徒名、ご使用端末の機種、OSバージョン（もし分かれば）、下記のソフトウェアバージョンをご連絡ください。
        </div>
        <div class="contact-popup__body__version no-close">
          ソフトウェアバージョン:{{ $version }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    mail() {
      return new URLSearchParams({
        subject: `お問い合わせ：九九～フリーモード～：ソフトウェアバージョン${this.$version}`,
        body: `以下の内容を入力して送信してください。
・教室名：
・お子さまのお名前：
・ご使用の端末機種名とOSバージョン:
・お問い合わせ内容（できるだけ詳細に）：`,
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.overlay {
  position: absolute;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.455);
  width: var(--app-width);
  height: var(--app-height);
  display: flex;
  justify-content: center;
  align-items: center;
}

.contact-popup {
  position: relative;
  background-color: white;
  width: 40%;
  height: 80%;
  border: 3px solid black;
  border-radius: 50px;

  &__close-button {
    width: 13%;
    position: absolute;
    top: 5%;
    right: 5%;
    cursor: pointer;
  }

  &__body {
    height: 100%;
    padding: 20% 5% 5% 5%;

    &__title {
      font-size: 1.7rem;
      text-align: center;
    }

    &__heading {
      font-size: 1.7rem;
      text-align: center;
    }

    &__mail {
      margin-top: 5%;
      font-size: 1.5rem;
      text-align: center;
    }

    &__description {
      margin-top:  10%;
      font-size: 1.5rem;
      padding: 0 5%;
    }

    &__version {
      margin-top: 5%;
      font-size: 1.4rem;
      padding: 0 5%;
      text-align: center;
    }
  }
}
</style>